import { RouteRecordRaw } from "vue-router";
import Layout from "@/views/layouts/index.vue";

const aiAssistantRouter: RouteRecordRaw[] = [
    {
        path: "/aiAssistant",
        name: "AiAssistant",
        component: Layout,
        redirect: "/aiAssistant",
        meta: {
            title: "AI助手",
            icon: "icon-AI"
        },
        children: [
            {
                path: "index",
                name: "AiAssistantIndex",
                component: () => import("@/views/pages/aiAssistant/index.vue"),
                meta: {
                    title: "AI助手",
                    hidden: true,
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default aiAssistantRouter;
